import React from "react";
import CustomTable from "../../components/CustomTable";
import { getVenues } from "../../../services/CommonServices";

const Venue = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage = 1, pageSize = 10) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "City",
      // key: "city",
      render: (row, index) => <span>{row?.city?.name ?? "-"}</span>,
      // subKey: 'name'
    },
    {
      label: "Venue Title",
      key: "title",
      render: (row) => (
        <span className="fw-semibold">{row?.title ?? "-"}</span>
      ),
    },
    {
      label: "Stages",
      key: "performanceVenueCount",
    },
    {
      label: "Gates",
      key: "gates",
    },
    {
      label: "Locations",
      key: "locations",
      render: (row) => {
        return (
          <span>
            <a href={row.location} target="_blank">
              Link
            </a>
          </span>
        );
      },
    },
  ];
  return (
    <CustomTable
      title="Venues"
      columns={columns}
      getHook={getVenues}
      store={"venue"}
      addBtnTitle="Create New Venue"
      deleteHook={"venue"}
    />
  );
};

export default Venue;
